import {
  DownloadAstroPayLandingImpression,
  DownloadAstroPayLinkCopied,
  HostedCheckoutImpression,
  HostedCheckoutPaymentCancelClicked,
} from '@services/ampli';

import { AmplitudeTracker } from './amplitudeTracker';

class AmplitudeAnalytics {
  private tracker: typeof AmplitudeTracker = AmplitudeTracker;

  public hostedCheckoutImpression = (paymentExternalId: string, merchantName?: string): void => {
    this.tracker.trackEvent(
      new HostedCheckoutImpression({
        payment_external_id: paymentExternalId,
        merchant_name: merchantName,
      }),
    );
  };

  public hostedCheckoutPaymentCancelClicked = (
    paymentExternalId: string,
    merchantName?: string,
  ): void => {
    this.tracker.trackEvent(
      new HostedCheckoutPaymentCancelClicked({
        payment_external_id: paymentExternalId,
        merchant_name: merchantName,
      }),
    );
  };

  public downloadAstroPayLandingImpression = (paymentExternalId: string): void => {
    this.tracker.trackEvent(
      new DownloadAstroPayLandingImpression({
        payment_external_id: paymentExternalId,
      }),
    );
  };

  public downloadAstroPayLinkCopied = (paymentExternalId: string): void => {
    this.tracker.trackEvent(
      new DownloadAstroPayLinkCopied({
        payment_external_id: paymentExternalId,
      }),
    );
  };
}

// eslint-disable-next-line no-restricted-exports
export default new AmplitudeAnalytics();
